import { type ComponentProps } from 'react'

import { HubConnectionState } from '@microsoft/signalr'
import { Badge, Flex, Tooltip } from 'antd'
import { useUnit } from 'effector-react'

import { $connectionState } from '../model/feedbacks-signalr.model'

const COLOR_BY_CONNECTION_STATE: Record<
  HubConnectionState,
  ComponentProps<typeof Badge>['status']
> = {
  [HubConnectionState.Connecting]: 'processing',
  [HubConnectionState.Connected]: 'success',
  [HubConnectionState.Reconnecting]: 'warning',
  [HubConnectionState.Disconnecting]: 'warning',
  [HubConnectionState.Disconnected]: 'default',
}

const TITLE_BY_CONNECTION_STATE: Record<HubConnectionState, string> = {
  [HubConnectionState.Connecting]: 'Подключение к серверу',
  [HubConnectionState.Connected]: 'Подключено',
  [HubConnectionState.Reconnecting]:
    'Потеряно соединение, попытка переподключения',
  [HubConnectionState.Disconnecting]: 'Отключение от сервера',
  [HubConnectionState.Disconnected]: 'Нет соединения с сервером',
}

export function SignalRStatus() {
  const connectionState = useUnit($connectionState)
  return (
    <Tooltip
      title={
        TITLE_BY_CONNECTION_STATE[connectionState] ?? 'Неизвестное состояние'
      }
    >
      <Flex>
        <Badge
          status={COLOR_BY_CONNECTION_STATE[connectionState] ?? 'default'}
        />
      </Flex>
    </Tooltip>
  )
}
